<template>
  <div
    class="product-selector"
    v-if="
      donation.formWizardCurrentStep === 0 && products && products.length > 0
    "
  >
    <div
      class="product"
      :class="{ isActive: product && p.id == product.id }"
      v-on:click="select(p)"
      v-for="p in products"
    >
      {{ getProductTypeMapping(p.producttype) }}
    </div>
  </div>
</template>

<script>
import {
  getParameterByName,
  getNameByDonationType,
  getProductTypeMapping,
  getUtmParams,
} from "../../helpers";
import gtm from "../../utils/gtm";
import { mapState } from "vuex";

export default {
  name: "product-selector",
  props: {
    productIds: {
      type: String,
      required: true,
    },
  },
  computed: mapState({
    donation: (state) => state.donation.donation,
    product: (state) => state.product.product,
    products: (state) => state.product.products,
  }),

  async created() {
    // Get the infos about the products
    const ids = this.productIds.split(",");
    await this.$store.dispatch("loadMultipleProducts", ids);

    // QUERY PARAM - Read the query to select the default product
    const p = getParameterByName("p", window.top.location.href);
    if (p) {
      const product = this.products.find((e) => e.id === p);
      if (product) {
        this.select(product);
      } else {
        this.select(this.products[0]);
      }
    } else {
      this.select(this.products[0]);
    }

    // Fire GTM events
    // For the primary product, fire a product detail
    // For the other one, fire a product impression
    // The product detail for the first item is fired in the "select" method already
    for (let i = 1; i < this.products.length; i++) {
      gtm.pushProductImpression(
        this.products[i].productname,
        this.products[i].id,
        this.products[i].producttype,
        getNameByDonationType(this.donation.type)
      );
    }
  },
  methods: {
    getProductTypeMapping(type) {
      return getProductTypeMapping(type);
    },
    select(product) {
      // Every time the use change the selection, fire new Producrt Detail
      gtm.pushProductDetail(
        product.productname,
        product.id,
        product.producttype,
        getNameByDonationType(this.donation.type)
      );

      this.$store.dispatch("getProductById", {
        id: product.id,
        source: window.top.location.href.split('?')[0] + getUtmParams(window.location.href),
        appealid: getParameterByName("t"),
        fundid: getParameterByName("f"),
      });
    },
  },
};
</script>

<style scoped>
.product-selector {
  display: flex;
  justify-content: space-around;
  padding: 10px 20px;
  background-color: var(--wwfWhite);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.product-selector .product {
  flex: 1;
  padding: 1rem;
  border-radius: 5px;
  color: var(--primaryColor);
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  text-transform: capitalize;
  cursor: pointer;
  transition: all ease 0.3s;
}

.product-selector .product:hover {
  background-color: var(--wwfGreyF3);
}

.product-selector .product.isActive {
  color: var(--wwfWhite);
  background-color: var(--primaryColor);
}
</style>


// WEBPACK FOOTER //
// ProductSelector.vue?09aa4aae